import { useAuth0 } from "@auth0/auth0-react";
import { useCallback } from "react";

const useAuthenticatedFetch = (): typeof fetch => {
    const { getAccessTokenSilently, loginWithRedirect } = useAuth0();

    return useCallback(
        async (input: RequestInfo | URL, init?: RequestInit) => {
            const redirectToLogin = async (): Promise<Response> => {
                const { location } = window;
                await loginWithRedirect({
                    appState: {
                        returnTo: `${location.pathname}${location.search}${location.hash}`,
                    },
                });
                return new Promise(() => {
                    // Will never resolve
                });
            };

            let accessToken: string | undefined;

            try {
                accessToken = await getAccessTokenSilently();
            } catch {
                return await redirectToLogin();
            }

            if (!accessToken) {
                return await redirectToLogin();
            }

            const modifiedInit = init ?? {};
            modifiedInit.headers = new Headers(modifiedInit.headers);
            modifiedInit.headers.set("Authorization", `Bearer ${accessToken}`);

            return await fetch(input, modifiedInit);
        },
        [getAccessTokenSilently, loginWithRedirect],
    );
};

export default useAuthenticatedFetch;
